import { useState, useEffect } from 'react';
import '../../../styles/comparisonEstimate.css';
import { COMPARISON_ESTIMATE_OPTIONS_INFO, COMPARISON_ESTIMATE_OPTION_LIST } from '../../../utils/constant';
import Button from '../../atoms/Button';
import Select from '../../atoms/Select';
import Header from '../../molecules/Header';
import classNames from 'classnames';
import useCheckPC from '../../../hooks/useCheckPC';
import { updateSubscription, updateUsageTime } from '../../../reducers/bookingEstimation';
import { useDispatch } from 'react-redux';
import { useBookingOptionContext } from '../../organisms/BookingOptionContext';
import ProfileEstimate from '../DriverDispatchManage/ProfileEstimate';

const ComparisonPartnerProfileFrame = ({ setOpenPartnerProfile }) => {
	const { isPC } = useCheckPC();
	const dispatch = useDispatch();

	const { selectedOptions, setSelectedOptions } = useBookingOptionContext();

	const [selectedOption1, setSelectedOption1] = useState(COMPARISON_ESTIMATE_OPTION_LIST[0]);
	const [selectedOption2, setSelectedOption2] = useState(COMPARISON_ESTIMATE_OPTION_LIST[1]);
	const [selectedOption3, setSelectedOption3] = useState(COMPARISON_ESTIMATE_OPTION_LIST[1]);

	/** 프로필 데이터 **/
	const [profileInfo, setProfileInfo] = useState([]);

	const selectedOptionInfo1 = COMPARISON_ESTIMATE_OPTIONS_INFO.find((item) => item.title === selectedOption1);
	const selectedOptionInfo2 = COMPARISON_ESTIMATE_OPTIONS_INFO.find((item) => item.title === selectedOption2);
	const selectedOptionInfo3 = COMPARISON_ESTIMATE_OPTIONS_INFO.find((item) => item.title === selectedOption3);

	const [selectedInfo, setSelectedInfo] = useState({});
	const [selectedIdxInfo, setSelectedIdxInfo] = useState(0);

	const HandleSelectedProduct = (subscription, usageTime) => {
		setSelectedOptions((prevState) => ({
			...prevState,
			subscription,
			usageTime,
		}));
		dispatch(updateSubscription(subscription))
		dispatch(updateUsageTime(usageTime))
		setOpenPartnerProfile(false)

		// 구글 시트쪽에 로우 추가 필요(?)
	}

	useEffect(() => {
		const getProfileData = async () => {
			const obj = [
				{
					img: 'https://manage.mosiler.com/AttachFile/Profile/20240409094425789.jpg',
					DriverName: '박*철',
					FullName: '박성철',
					DriverNo: '9817',
					Age: '40대',
					GraphData: [90, 100, 85, 100, 90, 85],
					PersonalHistory: [],
					EducationHistory: [],
					CertificateHistory: [],
					Feedback: null,
					Address: '안양 동안구',
					SmokingStatus: '비흡연',
					MarriedStatus: '기혼',
					BabyStatus: '유',
					Introduce: '적극적인 마인드로 성실히 임하겠습니다.',
					FeedBackNew: '교육 시 실내온도 체크등 세심한 부분까지 신경 쓰는 모습에서 전문성이 보였습니다.',
					FeedBackMosiler: '사전 준비가 철저하며, 영어 회화가 가능하여 외국인 VIP 운행위주로 수행하였습니다.',
				},
				{
					img: 'https://manage.mosiler.com/AttachFile/Profile//20241015143336993.jpg',
					DriverName: '천*승',
					FullName: '천대승',
					DriverNo: '10222',
					Age: '40대',
					GraphData: [90, 80, 90, 100, 90, 90],
					PersonalHistory: [],
					EducationHistory: [],
					CertificateHistory: [],
					Feedback: null,
					Address: '서울 광진구',
					SmokingStatus: '비흡연',
					MarriedStatus: '기혼',
					BabyStatus: '유',
					Introduce: '안전운전을 기본으로 가족처럼 모시겠습니다.',
					FeedBackNew: '부드러운 코너링이 인상적이었으며 좁은 길은 하차하여 직접 육안으로 확인하는 모습이 보기 좋았습니다.',
					FeedBackMosiler: '고객 평이 좋은 파트너로 지리에 밝아 바쁘게 움직이는 비지니스 운행에서 빛을 발합니다.',
				},
				{
					img: 'https://manage.mosiler.com/AttachFile/Profile/20240328144516873.jpg',
					DriverName: '정*곤',
					FullName: '정재곤',
					DriverNo: '9750',
					Age: '40대',
					GraphData: [80, 90, 95, 90, 90, 85],
					PersonalHistory: [
						// {
						// 	title: '장길동 운행',
						// 	startTime: '2024.01',
						// 	endTime: '2024.08',
						// },
						// {
						// 	title: '주식회사 장길동 의전 운전',
						// 	startTime: '2022.06',
						// 	endTime: '2023.12',
						// },
					],
					EducationHistory: [
						// {
						// 	title: '제주 XX 중학교 졸업',
						// 	startTime: '2024.01',
						// 	endTime: '2024.08',
						// },
						// {
						// 	title: '서울 XX 고등학교 졸업',
						// 	startTime: '2022.06',
						// 	endTime: '2023.12',
						// },
					],
					CertificateHistory: [
						// {
						// 	title: '정보처리기사 자격증 취득',
						// 	time: '2024.03',
						// },
						// {
						// 	title: '워드프로세서 1급 자격증 취득',
						// 	time: '2024.03',
						// }
					],
					// Feedback: {
					// 	Teacher: '양심규',
					// 	Date: '2024년 03월 02일',
					// 	Comment: '운전이 안정적 03'
					// },
					Feedback: null,
					Address: '서울 은평구',
					SmokingStatus: '비흡연',
					MarriedStatus: '미혼',
					BabyStatus: '무',
					Introduce: '안전을 최우선으로 합니다. 맡은 바 최선을 다하겠습니다.',
					FeedBackNew: '중저음의 목소리로 사람의 기분을 좋아지게 하는 온화한 미소를 가지고 있습니다.',
					FeedBackMosiler: '운행 중 발생하는 돌발상황에 유연한 대처로 고객들에게 평이 좋은 파트너 입니다.',
				}
			]
			setProfileInfo(obj)
			setSelectedInfo(obj[0])
		}
		getProfileData();
	}, [])

	const styleBtn = {
		border: '2px solid #fff'
	}

	return (
		<>
			{<Header headerTitle={'파트너 프로필'} onClickCloseBtn={() => setOpenPartnerProfile(false)} />}
			{!isPC && <div style={{
				position: 'fixed',
				zIndex: 12,
				left: '50%',
				transform: 'translate(-50%, 20%)',
				display: 'flex',
				flexDirection: 'row',
				top: '50px',
				justifyContent: 'center',
				width: '300px',
				alignItems: 'center',
				gap: '5px'
				// top: '30px',
				// width: '100%',
			}}>
				{profileInfo.length >= 1 && <>
					{profileInfo.map((data, idx) => (
						<Button
							style={styleBtn}
							styleType={selectedIdxInfo === idx ? 'secondary' : 'primary'}
							classes={'fit-content button-small'}
							onClick={() => {
								setSelectedInfo(profileInfo[idx])
								setSelectedIdxInfo(idx)
							}}>{`추천 ${idx + 1}`}</Button>
					))}
				</>}
			</div>}

			<div className={`comparison-estimate-wrap`}>
				<div className='comparison-estimate'>
					{isPC ?
						<>
							{profileInfo.length >= 1 && <>
								{profileInfo.map((data, idx) => (
									<div className={`estimate-item-custom ${idx >= 2 && 'pc'}`} >
										<div className='item-content'>
											<ProfileEstimate selectedPartnerInfo={data} modalClose={()=>setOpenPartnerProfile(false)} />
										</div>
									</div>
								))}
							</>}
						</>
						:
						<>
							<div className={`estimate-item-custom`} >
								<div className='item-content'>
									<ProfileEstimate selectedPartnerInfo={selectedInfo} modalClose={()=>setOpenPartnerProfile(false)}/>
								</div>
							</div>
						</>
					}

				</div>
			</div>
		</>
	);
};

export default ComparisonPartnerProfileFrame;
